import React from "react";

const TrackOrderLink = ({ payload }) => {
  return (
    <div>
      <a href={payload} target="_blank" rel="noopener noreferrer">
        Track Your Order
      </a>
    </div>
  );
};

export default TrackOrderLink;
